
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

interface Master {
  id: number;
  name: string;
  specialty: string[];
  experience: string;
  rating: number;
  price: string;
  avatar: string;
  description: string;
  skills: string[];
  availability: string;
}

const masters: Master[] = [
  {
    id: 1,
    name: '林雅婷老師',
    specialty: ['塔羅占卜', '愛情運勢'],
    experience: '15年',
    rating: 4.9,
    price: '388',
    avatar: 'https://public.readdy.ai/ai/img_res/b18ae5796d5d20c6113a22b96d2287ce.jpg',
    description: '專精塔羅占卜與愛情運勢分析，擅長解讀感情問題，幫助客戶找到內心答案。溫和親切的諮詢風格深受客戶喜愛。',
    skills: ['塔羅牌解讀', '愛情諮詢', '人際關係', '心靈療癒'],
    availability: '週一至週五 10:00-18:00'
  },
  {
    id: 2,
    name: '陳志明大師',
    specialty: ['八字算命', '紫微斗數'],
    experience: '25年',
    rating: 4.8,
    price: '588',
    avatar: 'https://readdy.ai/api/search-image?query=Wise%20elderly%20Chinese%20fortune%20teller%20master%20with%20traditional%20clothing%2C%20sitting%20in%20study%20room%20with%20ancient%20books%20and%20feng%20shui%20items%2C%20professional%20portrait%2C%20dignified%20appearance&width=300&height=300&seq=master2&orientation=squarish',
    description: '資深命理大師，精通八字命理與紫微斗數，擅長事業運勢、財運分析。多年來幫助無數客戶改善人生運勢。',
    skills: ['八字命理', '紫微斗數', '事業運勢', '財運分析'],
    availability: '週二至週日 09:00-17:00'
  },
  {
    id: 3,
    name: '王美華老師',
    specialty: ['星座運勢', '占星學'],
    experience: '12年',
    rating: 4.7,
    price: '298',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20professional%20female%20astrologer%20with%20modern%20style%2C%20sitting%20with%20star%20charts%20and%20celestial%20maps%2C%20bright%20office%20setting%2C%20confident%20smile%2C%20contemporary%20portrait&width=300&height=300&seq=master3&orientation=squarish',
    description: '專業占星師，深入研究西洋占星學，擅長個人星盤分析與流年運勢預測。用現代化的方式詮釋古老智慧。',
    skills: ['星座分析', '個人星盤', '流年運勢', '性格解析'],
    availability: '週一至週六 14:00-20:00'
  },
  {
    id: 4,
    name: '張道長',
    specialty: ['風水命理', '易經占卜'],
    experience: '30年',
    rating: 4.9,
    price: '888',
    avatar: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20Taoist%20master%20in%20traditional%20robes%2C%20sitting%20in%20temple%20with%20I-Ching%20books%20and%20feng%20shui%20compass%2C%20serene%20expression%2C%20ancient%20wisdom%20atmosphere&width=300&height=300&seq=master4&orientation=squarish',
    description: '道教傳承，精通易經八卦與風水命理。擅長居家風水調整、事業布局規劃。傳統與現代結合的諮詢方式。',
    skills: ['易經占卜', '風水調整', '事業布局', '運勢改善'],
    availability: '週三至週日 08:00-16:00'
  },
  {
    id: 5,
    name: '李心怡老師',
    specialty: ['塔羅占卜', '心靈諮詢'],
    experience: '8年',
    rating: 4.6,
    price: '268',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20gentle%20female%20tarot%20reader%20with%20healing%20energy%2C%20sitting%20with%20beautiful%20tarot%20deck%2C%20crystals%20and%20candles%2C%20soft%20natural%20lighting%2C%20peaceful%20atmosphere&width=300&height=300&seq=master5&orientation=squarish',
    description: '結合心理學與塔羅占卜，專注於內在成長與心靈療癒。溫暖的諮詢方式幫助客戶找到人生方向。',
    skills: ['塔羅療癒', '心理諮詢', '內在成長', '情緒調節'],
    availability: '週一至週五 13:00-19:00'
  },
  {
    id: 6,
    name: '黃金龍老師',
    specialty: ['紫微斗數', '姓名學'],
    experience: '20年',
    rating: 4.8,
    price: '488',
    avatar: 'https://readdy.ai/api/search-image?query=Middle-aged%20Chinese%20fortune%20teller%20with%20scholarly%20appearance%2C%20sitting%20with%20traditional%20Chinese%20divination%20tools%20and%20calligraphy%2C%20professional%20study%20room%20setting&width=300&height=300&seq=master6&orientation=squarish',
    description: '紫微斗數專家，同時精通姓名學與數字命理。擅長人生規劃與命名改運，理論與實務並重。',
    skills: ['紫微斗數', '姓名學', '數字命理', '人生規劃'],
    availability: '週二至週六 10:00-18:00'
  }
];

export default function BookingPage() {
  const [selectedMaster, setSelectedMaster] = useState<Master | null>(null);
  const [showBookingForm, setShowBookingForm] = useState(false);

  const handleBooking = (master: Master) => {
    setSelectedMaster(master);
    setShowBookingForm(true);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d4bi214rg8gnguu95e90', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        alert('預約申請已送出！占卜師將在24小時內與您聯繫確認預約時間。');
        setShowBookingForm(false);
        setSelectedMaster(null);
      } else {
        alert('預約失敗，請稍後再試。');
      }
    } catch (error) {
      alert('網路錯誤，請檢查網路連線後再試。');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">專業占卜師預約</h1>
          <p className="text-xl md:text-2xl mb-8 opacity-90">
            與資深命理大師一對一諮詢，為您解答人生疑惑
          </p>
          <div className="flex justify-center space-x-8 text-sm">
            <div className="flex items-center">
              <div className="w-4 h-4 flex items-center justify-center mr-2">
                <i className="ri-shield-check-line"></i>
              </div>
              專業認證
            </div>
            <div className="flex items-center">
              <div className="w-4 h-4 flex items-center justify-center mr-2">
                <i className="ri-time-line"></i>
              </div>
              彈性預約
            </div>
            <div className="flex items-center">
              <div className="w-4 h-4 flex items-center justify-center mr-2">
                <i className="ri-customer-service-line"></i>
              </div>
              一對一諮詢
            </div>
          </div>
        </div>
      </section>

      {/* Masters Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">專業占卜師團隊</h2>
            <p className="text-lg text-gray-600">
              精選資深命理大師，為您提供專業的命理諮詢服務
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {masters.map((master) => (
              <div key={master.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                <div className="p-6">
                  <div className="flex items-center mb-4">
                    <img
                      src={master.avatar}
                      alt={master.name}
                      className="w-16 h-16 rounded-full object-cover mr-4"
                    />
                    <div>
                      <h3 className="text-xl font-bold text-gray-900">{master.name}</h3>
                      <div className="flex items-center mt-1">
                        <div className="flex text-yellow-400">
                          {[...Array(5)].map((_, i) => (
                            <div key={i} className="w-4 h-4 flex items-center justify-center">
                              <i className={`ri-star-${i < Math.floor(master.rating) ? 'fill' : 'line'} text-sm`}></i>
                            </div>
                          ))}
                        </div>
                        <span className="text-sm text-gray-600 ml-2">{master.rating}</span>
                      </div>
                    </div>
                  </div>

                  <div className="mb-4">
                    <div className="flex flex-wrap gap-2 mb-3">
                      {master.specialty.map((spec, index) => (
                        <span
                          key={index}
                          className="px-3 py-1 bg-purple-100 text-purple-800 text-sm rounded-full"
                        >
                          {spec}
                        </span>
                      ))}
                    </div>
                    <p className="text-gray-600 text-sm mb-3">{master.description}</p>
                  </div>

                  <div className="space-y-2 mb-4">
                    <div className="flex items-center text-sm text-gray-600">
                      <div className="w-4 h-4 flex items-center justify-center mr-2">
                        <i className="ri-time-line"></i>
                      </div>
                      經驗：{master.experience}
                    </div>
                    <div className="flex items-center text-sm text-gray-600">
                      <div className="w-4 h-4 flex items-center justify-center mr-2">
                        <i className="ri-calendar-line"></i>
                      </div>
                      {master.availability}
                    </div>
                  </div>

                  <div className="flex items-center justify-between">
                    <div className="text-2xl font-bold text-purple-600">
                      NT$ {master.price}
                      <span className="text-sm text-gray-500 font-normal">/次</span>
                    </div>
                    <button
                      onClick={() => handleBooking(master)}
                      className="px-6 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      立即預約
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Booking Form Modal */}
      {showBookingForm && selectedMaster && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-md w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-xl font-bold text-gray-900">預約 {selectedMaster.name}</h3>
                <button
                  onClick={() => setShowBookingForm(false)}
                  className="text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-close-line text-xl"></i>
                  </div>
                </button>
              </div>

              <form onSubmit={handleSubmit} data-readdy-form id="booking-form">
                <input type="hidden" name="占卜師" value={selectedMaster.name} />
                <input type="hidden" name="服務項目" value={selectedMaster.specialty.join(', ')} />
                <input type="hidden" name="費用" value={`NT$ ${selectedMaster.price}`} />

                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      姓名 *
                    </label>
                    <input
                      type="text"
                      name="姓名"
                      required
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
                      placeholder="請輸入您的姓名"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      聯絡電話 *
                    </label>
                    <input
                      type="tel"
                      name="聯絡電話"
                      required
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
                      placeholder="請輸入您的聯絡電話"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      電子信箱
                    </label>
                    <input
                      type="email"
                      name="電子信箱"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
                      placeholder="請輸入您的電子信箱"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      希望預約時間 *
                    </label>
                    <input
                      type="datetime-local"
                      name="希望預約時間"
                      required
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      諮詢類型 *
                    </label>
                    <select
                      name="諮詢類型"
                      required
                      className="w-full px-3 py-2 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
                    >
                      <option value="">請選擇諮詢類型</option>
                      {selectedMaster.specialty.map((spec, index) => (
                        <option key={index} value={spec}>{spec}</option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      諮詢問題描述
                    </label>
                    <textarea
                      name="諮詢問題描述"
                      rows={4}
                      maxLength={500}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm resize-none"
                      placeholder="請簡述您想諮詢的問題（限500字）"
                    ></textarea>
                  </div>

                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-medium text-gray-900 mb-2">預約資訊確認</h4>
                    <div className="space-y-1 text-sm text-gray-600">
                      <p>占卜師：{selectedMaster.name}</p>
                      <p>服務項目：{selectedMaster.specialty.join(', ')}</p>
                      <p>諮詢費用：NT$ {selectedMaster.price}</p>
                      <p>可預約時間：{selectedMaster.availability}</p>
                    </div>
                  </div>
                </div>

                <div className="flex space-x-3 mt-6">
                  <button
                    type="button"
                    onClick={() => setShowBookingForm(false)}
                    className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    取消
                  </button>
                  <button
                    type="submit"
                    className="flex-1 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    確認預約
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
